import { filter, includes } from "ramda"
import { NEW_ACCOUNT_EDIT_PAGE } from "../PgaRecord/options"

export const getNavigationOptions = ({
  isCareerProfileDashboardEnabled,
} = {}) =>
  [
    {
      id: "dashboard",
      label: "dashboard",
      to: "/",
      isActive: (match, location) => {
        if (!location) return false
        return location.pathname === "/"
      },
    },
    {
      id: "profile",
      label: "My Directory Profile",
      to: "/profile/edit",
    },
    {
      id: "pga record",
      label: "My Official PGA Records",
      to: NEW_ACCOUNT_EDIT_PAGE,
      external: true,
    },
    {
      id: "job-preferences",
      label: "Job Search Preferences",
      to: "/job-preferences",
    },
    {
      id: "education-programs",
      label: "Education Programs",
      to: "/education/programs",
    },
    {
      id: "compensation-profile",
      label: "Compensation Profile",
      to: "/compensation-profile",
    },
    {
      id: "career-profile",
      label: "Career Profile",
      to: "/career",
    },
  ].filter(
    ({ id }) => isCareerProfileDashboardEnabled || id !== "career-profile",
  )

const typeNavigation = {
  MB: [
    "dashboard",
    "profile",
    "pga record",
    "job-preferences",
    "education-programs",
    "compensation-profile",
    "career-profile",
  ],
  ST: [
    "dashboard",
    "profile",
    "pga record",
    "job-preferences",
    "compensation-profile",
    "career-profile",
  ],
  AP: [
    "dashboard",
    "profile",
    "pga record",
    "job-preferences",
    "compensation-profile",
    "career-profile",
  ],
  PQ: [
    "dashboard",
    "job-preferences",
    "compensation-profile",
    "career-profile",
  ],
  QE: [
    "dashboard",
    "job-preferences",
    "compensation-profile",
    "career-profile",
  ],
}
const defaultNavigation = ["dashboard"]

const getNavOptions = (
  { type } = {},
  { isCareerProfileDashboardEnabled } = {},
) => {
  const typeDestiny = typeNavigation[type] || defaultNavigation
  const navOptions = getNavigationOptions({ isCareerProfileDashboardEnabled })
  return filter(({ id }) => includes(id, typeDestiny), navOptions)
}

export default getNavOptions
